export default __webpack_public_path__ + "static/media/Paws_up_account.27feb134.jpg";